<template>
  <div class="edit-event-choice text-small">
    <div class="p-1 text-small" v-for="option in options" :key="option.answer">
      <div @blur="onBlur(option)" @click="selectOption(option)">
        <font-awesome-icon
          v-if="option.checked"
          class="text-primary"
          :icon="['fas', 'dot-circle']"
        />
        <font-awesome-icon v-else :icon="['fal', 'circle']" />
        <div class="event-choice-label" v-html="content(option.label)"></div>
      </div>
    </div>
    <div class="mt-3">
      <input-text v-model="value.comment" placeholder="Kommentar hier tippen" />
    </div>
  </div>
</template>
<script>
import InputText from '@/components/UI/InputText';
import { mapState } from 'vuex';

export default {
  name: 'EditEventChoice',
  props: ['value', 'guests'],

  components: {
    InputText,
  },

  data() {
    return {
      allOptions: [
        {
          label: this.$t('event.dlgOption1'),
          checked: false,
          answer: 1,
        },
        {
          label: this.$t('event.dlgOption2'),
          checked: false,
          answer: 2,
        },
        {
          label: this.$t('event.dlgOption3'),
          checked: false,
          answer: 0,
        },
      ],
    };
  },

  // watch: {
  //   value: {
  //    handler(val){
  //      console.log("Guest chnaged to :", val.geuests);
  //    },
  //    deep: true
  // }
  // },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    options() {
      if (this.poll.options.limitedVotesPerEvent) return this.allOptions;
      const options = this.allOptions.filter((o) => o.answer != 2);
      return options;
    },
  },

  methods: {
    content(value, ) {
      if (!value) {
        return '';
      }

      const maxLimit = this.poll.options.guestsLimit;
      const inputElement = `<input type="text" id="md-event-guest" class="md-input"  value="${this.guests}"/>`;
      return String(value).replace('{i}', inputElement).replace('{n}', maxLimit);
    },

    updateChoiceValue(selected) {
      let eventChoice = this.value;
      console.log('Update choice value to:', selected,  eventChoice.guests);
      eventChoice.answer = selected;
      this.$emit('input', eventChoice );
    },

    onBlur(option) {
      const guestsElement = document.getElementById('md-event-guest');
      if( !guestsElement ) return;
      const guests = guestsElement.value;
      if (option.guests != guests) {
        const guests = document.getElementById('md-event-guest').value;
        let eventChoice = this.value;
        eventChoice.guests = guests;
        console.log('on blur update number of guests for:', option);
        this.$emit('input', eventChoice);
      }
    },

    selectOption(option) {
      console.log('Select option');
      Object.keys(this.options).forEach((key) => {
        this.options[key].checked = false;
      });
      option.checked = true;
      this.updateChoiceValue(option.answer);
    },
  },
  mounted() {
    let answer = this.value.answer;
    if (answer < 0) {
      return;
    }
    let option = this.options.find((o) => o.answer === answer);
    console.log('mounting - option:', answer, option);
    if (option) option.checked = true;
  },
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';

.event-choice-label {
  display: inline;
  margin-left: 10px;
}

input.md-input {
  border: none;
  border-radius: 0px;  
  border-bottom: 1px solid $mid-grey;
  padding: 0px 5px 5px;
  text-align: center;
  width: 35px;
  display: inline-block;
  font-size: 16px;
  background: transparent;
  box-shadow: 0px 1px 0px $light-grey;
  box-shadow: 0px 1px 0px $mid-grey;
}

input.md-input:focus {
  border: none;
  outline: none;
  box-shadow: 0px 2px 0px $primary;
}
</style>
